import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorStep } from './IndicatorStep';
import { ContentSnippetTranscriptComponent } from './types';
import { useListContentSnippetsQuery } from 'src/services/content-snippets/contentSnippetsApi';

export const ContentSnippetTrigger = ({
  transcriptComponent,
}: {
  transcriptComponent: ContentSnippetTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { content_snippet_ids: contentSnippetIds } = transcriptComponent;
  const { data } = useListContentSnippetsQuery();
  const contentSnippets = useMemo(() => {
    return data?.snippets || [];
  }, [data?.snippets]);

  const transcriptSnippetMapped = useMemo(
    () =>
      contentSnippetIds.map(contentSnippetId =>
        contentSnippets.find(
          snippet => snippet.content_snippet_id === contentSnippetId,
        ),
      ),
    [contentSnippetIds, contentSnippets],
  )?.[0];

  return (
    <IndicatorStep
      message={t('contentSnippetTrigger.message', {
        name:
          transcriptSnippetMapped?.name ||
          t('contentSnippetTrigger.deletedContentSnippet'),
      })}
    />
  );
};
